const Ellipse = ({ size = 8, fill = '#D9D9D9' }) => (
  <svg width={size} height={size} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="4" fill={fill} />
  </svg>
);

export default Ellipse;
